import type { ActivityStatus } from 'api/recoveryAi.types'

// The RAI case-detail header's badge redesign (AI-1024) collapses two of the
// wire's five statuses onto a neighbor's label + color rather than adding a
// third color to FeedbackStatusBadge's palette:
//   - `escalated` reads as unresolved work in progress — same orange pill as
//     `unresolved`, not its own yellow "Escalated" pill.
//   - `manually_resolved` reads as one green "Resolved" pill, same as the
//     AI's own `resolved` — the header doesn't distinguish who closed the
//     case the way the activity table's status column still does.
// `resolved` / `unresolved` / `pending` / `closed_by_operator` pass through
// unchanged. Case-detail-only: the order-rating detail's badgeStatus comes
// from a different input domain (resolutionStatusFor, keyed on
// resolvedBy.kind) and isn't affected by this mapping.
export const caseDetailBadgeStatusFor = (
  status: ActivityStatus
): ActivityStatus => {
  if (status === 'escalated') return 'unresolved'
  if (status === 'manually_resolved') return 'resolved'
  return status
}
